import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Flex } from 'Components/Base';
import Loading from 'Components/Loading';
import { isLogin, isLoading } from 'Redux/user-profile/selectors';

import { USER_PROFILE_LOGOUT } from '../../../Redux/user-profile/actions';

const Logout = ({ isLogin, isLoading, history }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isLoading) {
      if (isLogin) {
        dispatch({ type: USER_PROFILE_LOGOUT });
      } else {
        return history.replace('/');
      }
    }
  }, [isLoading, isLogin]);

  return (
    <Flex justifyContent="center" alignItems="center" height="100vh">
      <Loading />
    </Flex>
  );
};

const mapStateToProps = (state) => ({ isLogin: isLogin(state), isLoading: isLoading(state) });
export default connect(mapStateToProps, {})(Logout);
